import { z } from 'zod';

export const RevokeSessionSchema = z.object({
  sessionId: z.string().min(1, 'Session ID cannot be empty'),
});

export type IRevokeSessionDto = z.infer<typeof RevokeSessionSchema>;
